<template>
  <div class="beta">
    <div class="container">
      <div class="inner">
        <div style="text-align:center">
          <img src="@/assets/logo.svg" width="200" />
        </div>
        <h1>パスワードの再設定</h1>

        <p>入力して頂いたメールアドレスに、パスワード再設定用のメールを送信します。</p>

        <div class="guide-container">
          <p class="guide"></p>
        </div>

        <el-form label-width="150px">
          <el-form-item label="メールアドレス" prop="name">
            <el-input type="email" autocomplete="on" v-model="email"></el-input>
          </el-form-item>

          <div class="button-container">
            <button
              @click.prevent="sendResetMail"
              class="button register"
              :class="{'loading disabled': loading}"
            >{{ loading ? '送信中' : '送信'}}</button>
          </div>
        </el-form>

        <!-- <el-alert
          title="メールを送信しました"
          type="success"
          description="ご入力頂いたメールアドレスに確認用のメールを送信しました。メールに記載されているURLをクリックして本登録を完了してください。"
          show-icon
        ></el-alert>-->

        <el-alert
          :title="`エラーが発生しました (error code: ${errCode})`"
          type="error"
          :description="errDescription"
          show-icon
          v-show="err"
        ></el-alert>

        <button class="button white" style="margin-top: 20px" @click="back">サインインページに戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "ForgotPassword",
  data() {
    return {
      loading: false,
      err: false,
      errCode: "",
      errDescription: "",
      email: ""
    };
  },
  methods: {
    back() {
      this.$router.replace("/");
    },
    sendResetMail() {
      this.loading = true;
      let self = this;
      const auth = firebase.auth();

      auth
        .sendPasswordResetEmail(self.email)
        .then(function() {
          self.$router.replace("/");
        })
        .catch(function(err) {
          self.errCode = err.code;
          self.errDescription = err.message;
          self.loading = false;
          self.err = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
  text-align: left;
  margin: 35px 0;
}
.inner {
  max-width: 75%;
  margin: 0 auto;
}

.button-container {
  text-align: center;
}

.register {
  margin: 20px 0;
  vertical-align: middle;
  padding: 5px 30px;
  font-size: 0.9rem;
  border-radius: 20px;
  transition: padding 0.5s ease, opacity 0.5s ease, width 0.5s ease;
  img {
    width: 20px;
    vertical-align: middle;
  }
}

.loading {
  background-image: url("../../../assets/spinner.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 90%;
  background-size: 22px;
  padding: 5px 43px 5px 25px;
}
.guide-container {
  margin: 30px;
  font-weight: bold;
}
</style>